<template>
  <v-row>
    <v-col>
      <h3>{{ $t("forecasts.alerts.title") }}</h3>
      <v-simple-table v-if="keys.length > 0">
        <thead>
          <tr>
            <th>{{ $t("forecasts.alerts.criteria") }}</th>
            <th>{{ $t("forecasts.alerts.threshold") }}</th>
            <th v-for="(day, b) in datatable" :key="`day${b}`">
              {{ moment(day.date).format("ddd DD MMM") }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(key, i) in keys" :key="i">
            <td>{{ $t(`alerts.alertType.${key}`) }}</td>
            <td>
              <b
                >{{ datatable[0].alerts.find((map) => map.key == key).number }}
                {{ getUnit(key) }}</b
              >
            </td>
            <td v-for="(data, c) in datatable" :key="`data${c}`">
              <v-chip
                v-if="
                  hasAlert(data.alerts, key) !== null &&
                  hasAlert(data.alerts, key) !== false
                "
                class="white--text"
                :color="`${getConditionOfAlert(data.alerts, key)} lighten-1`"
              >
                <b>{{ displayDataWithKey(data.alerts, key) }}</b>
              </v-chip>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <template v-else>
        <v-card elevation="0" color="grey lighten-3">
          <v-card-text>
            <v-col class="pa-6 text-center">
              <h2>{{ $t("forecasts.alerts.noAlert") }}</h2>
              <v-btn
                :disabled="checkLimit"
                class="my-6"
                elevation="0"
                outlined
                color="dark"
                :to="`/alertes/v2?geoname=${$route.params.geoname}`"
              >
                <v-icon>mdi-bell</v-icon> {{ $t("forecasts.alerts.createBtn") }}
              </v-btn>
            </v-col>
          </v-card-text>
        </v-card>
      </template>
    </v-col>
    <v-col cols="12">
      <alerts-amphibien v-if="this.user.features.includes('taxons_amphibiens')" />
    </v-col>
  </v-row>
</template>

<script>
import api from "@/api";
import moment from "moment";
import { mapState } from "vuex";
import AlertsAmphibien from "./AlertsAmphibien.vue";
export default {
  components: { AlertsAmphibien },
  computed: {
    ...mapState(["user"]),

    checkLimit() {
      let limit = this.$checkLimit("alerts");
      if (limit) {
        if (this.alerts.length >= limit) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    },
  },
  data: () => ({
    datatable: [],
    alerts:[],
    keys: [],
    moment: moment,
  }),
  methods: {

    async getUserAlerts() {
      let res = await api.alert.getMapAlerts(this.user.id_user);
      res.map(map=>map.show = false);
      this.alerts = res;
      if (this.alerts.length == 0) {
        this.$router.push("/alertes/v2");
      }
    },
    getConditionOfAlert(alerts, key) {
      let alert = alerts.find((map) => map.key == key);

      if (alert)
        switch (key) {
          case "wind":
            return alert.fcast > alert.number ? "red" : "green";
          case "temp-min":
            return alert.fcast < alert.number ? "red" : "green";
          case "temp-max":
            return alert.fcast > alert.number ? "red" : "green";
          case "rain-max":
            return alert.fcast > alert.number ? "red" : "green";
          case "snow":
            return alert.fcast > alert.number ? "red" : "green";
          case "storm":
            return alert.fcast > alert.number ? "red" : "green";
          case "ice":
            return alert.fcast > alert.number ? "red" : "green";
          case "rain-now":
            return alert.fcast > alert.number ? "red" : "green";
          default:
            break;
        }
    },
    hasAlert(alerts, key) {
      let alert = alerts.find((map) => map.key == key);
      if (alert.fcast || alert.fcast == 0) {
        return true;
      } else {
        return false;
      }
    },
    getUnit(key) {
      let unit = "";
      switch (key) {
        case "temp-min":
          unit = "°C";
          break;
        case "temp-max":
          unit = "°C";
          break;
        case "wind":
          unit = "km/h";
          break;
        case "rain-max":
          unit = "mm";
          break;
      }
      return unit;
    },
    displayDataWithKey(alerts, key) {
      let alert = alerts.find((map) => map.key == key);
      if (alert) {
        if(key == "snow" || key == "ice")
        {
          return `${Math.round(alert.fcast)}/5`
        }else if (key == "rain-max"){
          return Math.round(alert.fcast * 100 ) / 100;
        }else{
          return Math.round(alert.fcast);
        }
      }
    },
    async getData() {
      let res = await api.forecast.getAlerts(
        this.user.id_user,
        this.$route.params.geoname
      );
      let keys = [];
      res.forEach((element) => {
        element.alerts.forEach((alert) => {
          if(alert.key != "rain-now" && alert.key != "storm")
          keys.push(alert.key);
        });
      });
      let uniq = [...new Set(keys)];
      res = res.slice(1, 8);
      this.datatable = res;
      this.keys = uniq;
    },
  },
  mounted() {
    this.getData();
    this.getUserAlerts()
  },
};
</script>

<style>
</style>